export default {
    init() {
        // ::
        // STEP 01
        // choose your gusto ---------------------------::
        // ____

        // ::
        // Sticky Menu Nav
        var menuSurrogateRatio = 1.1;
        var heroScrollSpeed = 3.5;
        var heroLogoScrollSpeed = 10;
        if (document.documentElement.clientWidth > 1000) {
            menuSurrogateRatio = 1.4;
            heroScrollSpeed = 2;
            heroLogoScrollSpeed = 5;
        }
        var menuSurrogateHeight = 1000;
        var gustoNavBreakpoint;
        var menuHero = $(".menu-hero");
        var menuHeroSurrogate = $(".menu-hero--surrogate");
        var menuHeroLogo = $(".menu-hero__logo");
        var scrollTop = 0;

        function animateMenu() {
            // Update the var with the page's scroll postition
            scrollTop = $(window).scrollTop();
          
            // Parallax magic
            menuHero.css("top", scrollTop / heroScrollSpeed);
            menuHeroLogo.css({
                "top": scrollTop / heroLogoScrollSpeed,
                "opacity" : (1 - (scrollTop / 300))
            });

            // Stick carousel arrows once we get to the bottom of the wallpaper area
            if (scrollTop >= gustoNavBreakpoint) {
                $(".menu--nav, .menu--gusto-carousel--arrow").addClass("sticky");
            } else {
                $(".menu--nav, .menu--gusto-carousel--arrow").removeClass("sticky");
            }
            // Repeat!
            window.requestAnimationFrame(animateMenu);
        }

        function menuScrollInit() {
            // set the height of the menu surrogate to the max of either the screen-based height, or 700 to make sure visibilty is correct if images take too long to load
            menuHeroSurrogate.height(Math.max(menuHero.height() * menuSurrogateRatio, 700));
            gustoNavBreakpoint = $(".menu--wallpaper").offset().top - parseInt($(window).height() - $(".menu--wallpaper").height());
            window.requestAnimationFrame(animateMenu); 
        }
        
        setTimeout(function(){
            menuScrollInit();
        },300);

        $(window).on("resize", function(){
            menuScrollInit();
        });

        $('.menu--gusto-carousel').slick({
            arrows: true,
            accessibility: false,
            fade: false,
            infinite: true,
            speed: 1000,
            draggable: false,
            waitForAnimate: true,
            nextArrow: $('.menu--gusto-carousel--arrow.next'),
            prevArrow: $('.menu--gusto-carousel--arrow.prev'),
            asNavFor: '.menu--wallpaper--carousel, .menu--gusto-info--carousel'
        });

        $('.menu--gusto-carousel, .menu--wallpaper--carousel, .menu--gusto-info--carousel').on(
            'beforeChange',
            (event, slick, currentSlide, nextSlide) => {
                changeGustoCarouselColors(nextSlide);
            }
        );

        $('.menu--wallpaper--carousel').slick({
            arrows: false,
            fade: true,
            accessibility: false,
            infinite: true,
            draggable: false,
            waitForAnimate: true,
            adaptiveHeight: false,
            speed: 1000
        });

        $('.menu--gusto-info--carousel').slick({
            arrows: false,
            fade: true,
            accessibility: false,
            infinite: true,
            draggable: false,
            waitForAnimate: true,
            adaptiveHeight: true
        });

        const menuNavItems = $('.menu--nav-item');
        let activeGustoIndex = 0;
        let activeGustoColor = menuNavItems.eq(0).attr('data-gusto-color');
        let nextGustoColor = menuNavItems.eq(1).attr('data-gusto-color');
        const nextArrow = $('.menu--gusto-carousel--arrow.next');
        const prevArrow = $('.menu--gusto-carousel--arrow.prev');
        let prevGustoColor = '#000';
        const carouselBadge = $('.menu--gusto-carousel--badge svg');
        const carouselTitle = $('.menu--gusto-carousel--name--stacked');

        // Changes active nav to new index, used for clicks on nav and for arrow carousel changes
        function changeGustoCarouselColors(newIndex = activeIndex) {
            activeGustoColor = menuNavItems.eq(newIndex).attr('data-gusto-color');

            // Get & update colors for carousel arrows based on newly active gusto
            prevGustoColor = menuNavItems.eq(newIndex - 1).attr('data-gusto-color');
            prevArrow.css('background-color', prevGustoColor);
            nextGustoColor = menuNavItems.eq(newIndex + 1).attr('data-gusto-color');
            nextArrow.css('background-color', nextGustoColor);

            // Mark new active nav item as active
            $('.menu--nav-item').removeClass('menu--nav-item--active');
            menuNavItems.eq(newIndex).addClass('menu--nav-item--active');

            // Update the color of the gusto badge floating over the bowls
            // setTimeout(() => {
                // console.log(activeGustoColor);
                // carouselBadge.find('path').css('fill', activeGustoColor);
                // carouselTitle.css({color:activeGustoColor});
            // }, 1000);
        }

        // Set badge to color of first gusto
        carouselBadge.find('path').css('fill', activeGustoColor);

        // Set next nav arrow background to next slide color
        $('.menu--gusto-carousel--arrow.next').css('background-color', nextGustoColor);

        // Handle clicks of gusto nav items
        $('.menu--nav').on('click', '.menu--nav-item', function(e) {
            activeGustoIndex = $(this).index();
            changeGustoCarouselColors(activeGustoIndex);
            // Advance slider to new index
            $('.menu--gusto-carousel').slick('slickGoTo', activeGustoIndex);
        });


        // ::
        // STEP 02
        // choose your protein ---------------------------::
        // ____
        $('.menu--protein-carousel').slick({
            arrows: true,
            // accessibility: false,
            fade: false,
            infinite: true,
            speed: 1000,
            draggable: true,
            nextArrow: $('.menu--protein-carousel--arrow.next'),
            prevArrow: $('.menu--protein-carousel--arrow.prev'),
            asNavFor: '#protein-info',
            adaptiveHeight: false
        });

        $('#protein-info').slick({
            arrows: false,
            fade: true,
            accessibility: false,
            infinite: true,
            draggable: false,
            waitForAnimate: false,
        });

        // ::
        // STEP 03
        // choose your style ---------------------------::
        // ____
        $('.menu--style-carousel').slick({
            arrows: true,
            // accessibility: false,
            fade: false,
            infinite: true,
            speed: 1000,
            draggable: true,
            nextArrow: $('.menu--style-carousel--arrow.next'),
            prevArrow: $('.menu--style-carousel--arrow.prev'),
            asNavFor: '#styles-info',
            adaptiveHeight: false
        });

        $('#styles-info').slick({
            arrows: false,
            fade: true,
            accessibility: false,
            infinite: true,
            draggable: false,
            waitForAnimate: false
        }); 
    },
    finalize() {}
};
